import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import Ajax from "./AJAX.jsx";
import RecursiveField2 from "./RecursiveField2.jsx";


const PostField = (props)=>
{
   const editFieldStyle =
   {
      border:"1px solid black",
      minHeight:200,
      width:400,
      fontSize:20,
   }
   return(
      <div>
         <textArea style={editFieldStyle} value={props.payload}
            onChange={props.update}/>
      </div>
         )
}


class TestAPI extends React.Component {
     constructor(props)
   {
      super();
      
      this.state = new Object();
     
      //this.state.urlPrefix = "";
      this.state.url = "";
      this.state.user = null;
      this.state.errors = [];
      this.state.result = null;
      this.state.method = "GET";
      this.state.payload = "";
      this.updatePrefix = function(e){
         this.setState({urlPrefix:e.target.value})
      }.bind(this);

      this.updateURL = function(e) {
         this.setState({url:e.target.value})
      }.bind(this);

      this.receiveResponseObject = function(responseObj)
      {
         console.log(responseObj);
         this.setState({errors: responseObj.error});
         this.setState({result: responseObj.result});
         this.setState({user: responseObj.result});
      }.bind(this);

      this.performQuery = function()
      {
         if(this.state.url == "")
         {
            this.setState({errors: ["url is empty"]});
         }
         else
         {
            var payloadAsJSONObject = null;
            //console.log("payload from client: " + this.state.payload.replace(/[\n\r]/g, ''));
            //console.log(JSON.parse(this.state.payload));
            try{
                payloadAsJSONObject = JSON.parse(this.state.payload);
            }
            catch(e)
            {
               console.log("COuld not parse payload: ", e);
            }
            this.props.appCallbacks.performAjaxRequest(this.state.url, this.state.method,
            payloadAsJSONObject, this.receiveResponseObject);
            //this.state.payload.replace(/[\n\r]/g, ''), this.receiveResponseObject);
         }
      }.bind(this);

      this.updateMethod = function(e)
      {
        this.setState({method:e.target.value})
      }.bind(this);
    
      this.updatePayload = function(e)
      {
        this.setState({payload:e.target.value})
      }.bind(this);
   }

   componentDidMount()
   {
      console.log("Test mount");
   }

   componentWillUnmount()
   {
      console.log("Test unmount");
   }


   render() {
      console.log("Render Test API");
      return ( 
         <div>
            <h1 style={{display:'block'}}> Test API</h1>
{/*
             Prefix: <input style={{width:500, fontSize:20}} type="text" name="url prefix"
             value={"http://localhost/~sunehede/lydfelt/web/REST_API/"}
             onChange={this.updatePrefix}/>
             <br/><br/>
            */} 
            URL: <input style={{width:500, fontSize:20}} type="text" name="url" value={this.state.url}
            onChange={this.updateURL}/>
            <br/>
            <br/>
            <input type="radio" name="Method" onChange={this.updateMethod} value="GET" defaultChecked/> Get<br/>
            <input type="radio" name="Method" onChange={this.updateMethod} value="PUT"/> Put<br/>
            <input type="radio" name="Method" onChange={this.updateMethod} value="POST"/> Post<br/>
            <input type="radio" name="Method" onChange={this.updateMethod} value="DELETE"/> Delete<br/>

            <br/>
            {this.state.method == "POST" || this.state.method == "PUT" ? <PostField update={this.updatePayload} payload={this.state.payload} />: null }
            <button onClick = {this.performQuery}>Perform Query</button>
            <br/>
            {this.state.errors.map((err, i) =>
            <span key = {i} className="error">{err}   <br/></span>)}
            <br/>
            {this.state.result != null ? <RecursiveField2 elem={this.state.result} /> : null}
         </div>
      );
   }
}

export default TestAPI;


// WEBPACK FOOTER //
// ./js/TestAPI.jsx